export class Stability {

    calculateStandardDeviation(data: number[]): number {
        let sum = 0;
        let counter = 0;

        for (let i = data.length - 1; i >= 0; i--) {
            sum = sum + data[i];
            counter = counter + 1;
        }

        const average: number = sum / counter;
        let varianzSum = 0;

        for (let i = Math.floor(data.length / 2); i < data.length - 4; ++i) {
            varianzSum = varianzSum + Math.pow(((data[i]) - average), 2);
            counter = counter + 1;
        }

        const varianz: number = varianzSum / average;
        const standardAbweichung: number = Math.sqrt(varianz);
        const standardAbweichungProzent: number = standardAbweichung / average * 100;
        const stability: number = 100.0 - standardAbweichungProzent;

        return stability;
    }

}
